/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline. Keeping your custom
* Javascript in this file will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/

(function () {

  // Below are example event listeners. They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

  // Event listeners available for custom functionality
  // Uncomment below for debugging in development only

  // document.addEventListener('theme:variant:change', function (event) {
  //   var variant = event.detail.variant;
  //   var container = event.target;
  //   if (variant) {
  //     console.log('Container:', container);
  //     console.log('Variant:', variant);
  //   }
  // });

  // document.addEventListener('theme:cart:change', function (event) {
  //   var cart = event.detail.cart;
  //   if (cart) {
  //     console.log('Cart:', cart);
  //   }
  // });

  // Removed console.logs for production performance
  // document.addEventListener('theme:cart:init', (e) => { console.log('theme:cart:init', e); });
  // document.addEventListener('theme:scroll', e => { console.log(e); });
  // document.addEventListener('theme:scroll:up', e => { console.log(e); });
  // document.addEventListener('theme:scroll:down', e => { console.log(e); });
  // document.addEventListener('theme:resize', e => { console.log(e); });

  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ✅ Autoplay de videos solo en escritorio y manejo en móviles
  document.addEventListener("DOMContentLoaded", function () {
    setTimeout(() => {
      const videos = document.querySelectorAll("video.media-video");

      if (window.innerWidth > 768) {
        // Escritorio — activar autoplay
        videos.forEach(video => {
          video.setAttribute("autoplay", "true");
          video.setAttribute("muted", "true");
          video.setAttribute("playsinline", "true");
          video.setAttribute("loop", "true");
          video.play().catch(() => {});
        });
      } else {
        // Móvil — desactivar autoplay por seguridad y evitar bloqueos
        videos.forEach(video => {
          video.pause();
          video.removeAttribute("autoplay");
        });
      }
    }, 300); // Espera breve para asegurar que el DOM ya montó los videos
  });

  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

})();
